"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var formatting_1 = require("./formatting/formatting");
var metrics_engine_1 = require("@tableau/metrics-engine");
var styles_1 = require("./styles/styles");
var SparkLine_1 = require("./SparkLine");
var isSingleNumberMetric = function (data) { return data ? data.length <= 1 : true; };
var MetricCardWithTimeSeries = /** @class */ (function (_super) {
    __extends(MetricCardWithTimeSeries, _super);
    function MetricCardWithTimeSeries() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MetricCardWithTimeSeries.prototype.render = function () {
        var metricNumber = formatting_1.formatDataPointAsMetricNumber(metrics_engine_1.getInitialValue(this.props.data), this.props.measureFormat);
        var lastRefreshedLabel = this.props.formattedLabel ||
            (this.props.lastUpdatedTimestamp ? formatting_1.formatRefreshedSince(this.props.lastUpdatedTimestamp) : '');
        return (React.createElement("div", { "data-tb-test-id": this.props.testId, style: containerStyle },
            React.createElement("div", { "data-tb-test-id": 'metric-card-ban', style: banStyle(isSingleNumberMetric(this.props.data)) }, isSingleNumberMetric(this.props.data) && React.createElement("div", { style: { alignSelf: 'center' } }, metricNumber)
                || metricNumber),
            React.createElement("div", { style: comparisonStyle }),
            this.props.data && this.props.data.length > 1 &&
                React.createElement("div", { style: timeSeriesContainerStyle },
                    React.createElement(SparkLine_1.ResizableSparkLine, { data: this.props.data, strokeWidth: 2, testId: 'time-series' })),
            React.createElement("div", { style: lastUpdatedTimestampStyle }, lastRefreshedLabel)));
    };
    return MetricCardWithTimeSeries;
}(React.PureComponent));
exports.MetricCardWithTimeSeries = MetricCardWithTimeSeries;
var timeSeriesContainerStyle = { width: '200px', height: '40px' };
var containerStyle = {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: '32px',
    paddingBottom: '10px',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
};
var banStyle = function (singleNumberMetric) { return ({
    fontSize: singleNumberMetric ? '40px' : '34px',
    color: styles_1.MetricBlue,
    marginBottom: '8px',
    fontWeight: 'lighter',
    lineHeight: 'normal',
    flexGrow: 1,
    display: 'flex'
}); };
var comparisonStyle = {
    fontSize: '14px',
    color: '#333333',
    fontWeight: 'lighter'
};
var lastUpdatedTimestampStyle = {
    fontSize: '12px',
    color: '#666666',
    marginTop: '16px',
    fontWeight: 'lighter'
};
//# sourceMappingURL=MetricCardWithTimeSeries.js.map